"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCreator = void 0;
var analytics_layer_1 = require("@pmi/analytics-layer");
var certificationClick_1 = require("./certificationClick");
var creatorMappings = (_a = {},
    _a[analytics_layer_1.CertificationClickEventNames.CertificationClick] = certificationClick_1.certificationClick,
    _a);
var getCreator = function (eventName) { return creatorMappings[eventName]; };
exports.getCreator = getCreator;
